'use strict';

export default class UserLoginForm {
  constructor() {
    // adding forget password link
    (function() {
        var form = $('form.user-login-form');
        if(form.length < 1) return;
        form.find('.form-actions').append(
            `<div class="forget-password display-inline"><a href="/user/password" class="link text-white">Forgot password?</a></div>`
        );
    })()
  }
}
